import Modal from "react-modal";
import "../../../reservation.css";
import { names } from "../../../Styles/names";
import { useEffect, useState } from "react";
import { LoadingIframe } from "./LoadingIframe";

const ModalTyr = ({
  room_type_panorama,
  ModalStatusTyr,
  setModalStatusTyr,
}) => {
  const [loadingIframe, setLoadingIframe] = useState(true);

  return (
    <Modal
      isOpen={ModalStatusTyr}
      className={`modal-wrapperTyr ${names.backgrond.primary}`}
      onRequestClose={() => setModalStatusTyr(false)}
      overlayClassName="modal-overlayTyr"
      shouldCloseOnOverlayClick={true}
      size={"sm"}
    >
      <div className="modal-headerTyr">
        <h2
          className={names.text.secondary}
          style={{
            textAlign: "center",
            fontSize: "18px",
            lineHeight: 1,
          }}
        >
          Room Tour
        </h2>
        <button
          onClick={() => setModalStatusTyr(false)}
          className={`modal-close-buttonTyr ${names.text.secondary}`}
        >
          ×
        </button>
      </div>
      <div className="modal-bodyTyr">
        <LoadingIframe loading={loadingIframe} />
        <iframe
          className="iframeTyr"
          loading="lazy"
          alt="room-tour"
          onLoad={() => setLoadingIframe(false)}
          src={room_type_panorama}
        />
      </div>
    </Modal>
  );
};

export { ModalTyr };
